import {
  Button,
  InputAdornment,
  MenuItem,
  Modal,
  TextField,
} from "@mui/material";
import { createContext, useContext, useMemo, useState, useEffect } from "react";
import { Context as PedidoContext } from "./DashPedidoMaquinariascreen";
import Agriculture from "@mui/icons-material/Agriculture";
import { ValTextAndNumber } from "../../../../../Validators/ValTextAndNumber";
import { ValOnlyNumber } from "../../../../../Validators/ValOnlyNumber";
import { ValPedidoFinanciamiento } from "./Validators/ValPedidoFinanciamiento";
import Swal from "sweetalert2";
import request from "../../../../../Helpers/API";
import { useHistory } from "react-router-dom";
import { FormatMoney } from "../../../../../Helpers/FormatNumber";
import CreateIcon from "@mui/icons-material/Create";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";
import { Moneda } from "../../../../../Helpers/Moneda";
import { LoaderScreen } from "../../../../components/LoaderScreen";
import DeleteIcon from "@mui/icons-material/Delete";
import SendIcon from "@mui/icons-material/Send";

import { TablaAmortizacionesModal } from "./Modales/TablaAmortizacionesModal";
import { ValPedidoFinanciamientoTablaAmortizacion } from "./Validators/ValPedidoFinanciamientoTablaAmortizacion";

const Context = createContext(null);

export default function DashPedidoMaquinariaDetalleFinanciamiento({
  setBottonguardar,
  idclienteSolicitud
}) {
  const history = useHistory();
  const folio = useContext(PedidoContext);
  const [stateFinanciamiento, setStateFinanciamiento] = useState({
    open: false,
    folio: folio.state.folio,
    docto: -1,
    tipoAmortizacion: folio.state.tipo_solicitud === 'J' ? "N" : "M",
  });
  const [unidades, setUnidades] = useState([]);
  const [info, setInfo] = useState({});
  const [valorInsoluto, setValorInsoluto] = useState(0);
  const [tipoAmortizacion, setTipoAmortizacion] = useState(folio.state.tipo_solicitud === 'J' ? "N" : "M");

  const [tablaAmortizacion, setTablaAmortizacion] = useState({
    tasa: 0,
    plazo: "",
    importe: 0,
    inicio: "",
    binicio: "",
    bimporte: "",
    bplazo: "",
    btasa: "",
  });


  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });




  const openModal = (docto) => {
    setStateFinanciamiento({
      ...stateFinanciamiento,
      open: true,
      docto,
      tipoAmortizacion: tipoAmortizacion,
      valorInsoluto: valorInsoluto,
    });
  };
  const contextValue = useMemo(
    () => ({
      stateFinanciamiento,
      setStateFinanciamiento,
    }),
    [stateFinanciamiento, setStateFinanciamiento]
  );
  const onValidarCondicionesOperacion = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SolicitudCredito/enviarCondicionesOperacion?folio=${folio.state.folio}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });

        history.push("/DashClientes/Solicitud_Credito", {idcliente: idclienteSolicitud } );
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
      });
  };
  useEffect(() => {
    if (
      folio.state.folio === undefined ||
      folio.state.folio === null ||
      folio.state.folio.length != 13
    ) {
      history.push("/DashClientes/solicitudcreditoGenerar", {
        folio: folio.state.folio,
        idcliente: folio.state.idcliente,
      });
      return;
    }

    if (folio.state.folio !== undefined && folio.state.folio.length === 13) {
      setBottonguardar(
        <div
          className="pedido-maquinaria-container-footer-guardar"
          onClick={() => onValidarCondicionesOperacion()}
        >
          VALIDAR CONDICIONES <SendIcon />
        </div>
      );
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(`PedidoFinanciamiento/Listado?folio=${folio.state.folio}`)
      .then((result) => {
        const sumaImportes = result.detalle_financiamiento.reduce(
          (acc, item) => acc + (parseFloat(item.importefinanciar) || 0),
          0
        );

        const valorInsoluto =
          (parseFloat(result.info.valor_operacion) || 0) - sumaImportes;

        setUnidades(result.detalle_financiamiento);
        setInfo(result.info);
        setValorInsoluto(valorInsoluto);
        if (
          result.info.tipo_amortizacion !== null &&
          result.info.tipo_amortizacion !== undefined &&
          result.info.tipo_amortizacion !== ""
        ) {
          setTipoAmortizacion(result.info.tipo_amortizacion);
        }

        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
      });
  }, [stateFinanciamiento.open]);

  const EliminarRegistro = (item) => {
    Swal.fire({
      title: "Deseas eliminar el registro?",
      showDenyButton: true,
      showCancelButton: true,
      showConfirmButton: false,
      confirmButtonText: "Save",
      cancelButtonText: "Cancelar",
      denyButtonText: `Eliminar`,
    }).then((result) => {
      if (result.isDenied) {
        setLoader({ ...loader, mostrar: true });
        request
          .get(
            `PedidoFinanciamiento/Delete?folio=${item.folio}&docto=${Number(
              item.docto
            )}`
          )
          .then((result) => {
            const sumaImportes = result.detalle_financiamiento.reduce(
              (acc, item) => acc + (parseFloat(item.importefinanciar) || 0),
              0
            );
            const valorInsoluto =
              (parseFloat(result.info.valor_operacion) || 0) - sumaImportes;

            setUnidades(result.detalle_financiamiento);
            setInfo(result.info);
            setValorInsoluto(valorInsoluto);
            if (
              result.info.tipo_amortizacion !== null &&
              result.info.tipo_amortizacion !== undefined &&
              result.info.tipo_amortizacion !== ""
            ) {
              setTipoAmortizacion(result.info.tipo_amortizacion);
            }

            setLoader({ ...loader, mostrar: false });
          })
          .catch((error) => {
            setLoader({ ...loader, mostrar: false });
            Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
          });
      }
    });
  };
  console.log(info)
  const EliminarTodosRegistro = () => {
    Swal.fire({
      title: "¿Deseas eliminar todos los registros?",
      showDenyButton: true,
      showCancelButton: true,
      showConfirmButton: false,
      confirmButtonText: "Save",
      cancelButtonText: "Cancelar",
      denyButtonText: `Eliminar`,
    }).then((result) => {
      if (result.isDenied) {
        setLoader({ ...loader, mostrar: true });
        request
          .get(`PedidoFinanciamiento/DeleteAll?folio=${folio.state.folio}`)
          .then((result) => {
            const sumaImportes = result.detalle_financiamiento.reduce(
              (acc, item) => acc + (parseFloat(item.importefinanciar) || 0),
              0
            );
            const valorInsoluto =
              (parseFloat(result.info.valor_operacion) || 0) - sumaImportes;

            setUnidades(result.detalle_financiamiento);
            setInfo(result.info);
            setValorInsoluto(valorInsoluto);
            if (
              result.info.tipo_amortizacion !== null &&
              result.info.tipo_amortizacion !== undefined &&
              result.info.tipo_amortizacion !== ""
            ) {
              setTipoAmortizacion(result.info.tipo_amortizacion);
            }

            setLoader({ ...loader, mostrar: false });
          })
          .catch((error) => {
            setLoader({ ...loader, mostrar: false });
            Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
          });
      }
    });
  };

  const onCrearTablaAmortizacion = () => {
    var result = ValPedidoFinanciamientoTablaAmortizacion(tablaAmortizacion);

    if (result.isValid === false) {
      Swal.fire(
        "PEDIDO DE MAQUINARIA",
        JSON.stringify(result.mensaje),
        "error"
      );
    } else if (result.post.importe < 1) {
      Swal.fire(
        "PEDIDO DE MAQUINARIA",
        "El importe no puede ser menor o igual a 0 para generar la tabla",
        "error"
      );
      return;
    } else if (result.post.tasa < 1) {
      Swal.fire(
        "PEDIDO DE MAQUINARIA",
        "La tasa no puede ser menor o igual a 0 para generar la tabla",
        "error"
      );
      return;
    } else {
      result.post.folio = folio.state.folio;
      result.post.valor_total = info.valor_operacion;

      request
        .post("PedidoFinanciamiento/TablaAmortizaciones", result.post)
        .then(async (result) => {
          const sumaImportes = result.detalle_financiamiento.reduce(
            (acc, item) => acc + (parseFloat(item.importefinanciar) || 0),
            0
          );
          const valorInsoluto =
            (parseFloat(result.info.valor_operacion) || 0) - sumaImportes;

          setUnidades(result.detalle_financiamiento);
          setInfo(result.info);
          setValorInsoluto(valorInsoluto);
          if (
            result.info.tipo_amortizacion !== null &&
            result.info.tipo_amortizacion !== undefined &&
            result.info.tipo_amortizacion !== ""
          ) {
            setTipoAmortizacion(result.info.tipo_amortizacion);
          }

          setLoader({ ...loader, mostrar: false });
        })
        .catch((error) => {
          Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "info");
        });
    }
  };
  return (
    <Context.Provider value={contextValue}>
      <div className="pedido-maquinaria-unidades-container scroll">
        <LoaderScreen loader={loader} />
        <div className="full scroll-4">
          {folio.state.tipo_solicitud === "O" ? (
            <div className="pedido-maquinaria-detalle-financiamiento-container">
              <div className="pedido-maquinaria-detalle-financiamiento-container-info">
                <div className="pedido-maquinaria-detalle-financiamiento-container-info-cuadro">
                  <div className="pedido-maquinaria-detalle-financiamiento-container-info-cuadro-textos">
                    <div className="info-cuadro-textos-container">
                      <span className="info-cuadro-textos-titulos">
                        Importe:
                      </span>
                      <div className="info-cuadro-textos-datos">
                        <div>$</div>
                        <div>{FormatMoney(info.precio)}</div>
                      </div>
                    </div>
                    <div className="info-cuadro-textos-container">
                      <span className="info-cuadro-textos-titulos">
                        Descuento:
                      </span>
                      <div className="info-cuadro-textos-datos">
                        <div>$</div>
                        <div>{FormatMoney(info.descuento)}</div>
                      </div>
                    </div>
                    <div className="info-cuadro-textos-container">
                      <span className="info-cuadro-textos-titulos">Total:</span>
                      <div className="info-cuadro-textos-datos">
                        <div>$</div>
                        <div>{FormatMoney(info.total)}</div>
                      </div>
                    </div>
                    <div className="info-cuadro-textos-container">
                      <span className="info-cuadro-textos-titulos">
                        Deposito:
                      </span>
                      <div className="info-cuadro-textos-datos">
                        <div>$</div>
                        <div>{FormatMoney(info.deposito)}</div>
                      </div>
                    </div>
                    <div className="info-cuadro-textos-container">
                      <span className="info-cuadro-textos-titulos">
                        Valor de operación:
                      </span>
                      <div className="info-cuadro-textos-datos">
                        <div>$</div>
                        <div>{FormatMoney(info.valor_operacion)}</div>
                      </div>
                    </div>
                  </div>
                  <div className="pedido-maquinaria-detalle-financiamiento-container-info-cuadro-botones radio-group scroll">
                    <label>
                      <input
                        type="radio"
                        name="opcion"
                        value="N"
                        checked={tipoAmortizacion === "N"}
                        onChange={() => setTipoAmortizacion("N")}
                        disabled={info.tipo_amortizacion !== null}
                      />
                      Amortización Normal
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="opcion"
                        value="M"
                        checked={tipoAmortizacion === "M"}
                        onChange={() => setTipoAmortizacion("M")}
                        disabled={info.tipo_amortizacion !== null}
                      />
                      Amortizaciones variables de capital
                    </label>

                    <label>
                      <input
                        type="radio"
                        name="opcion"
                        value="T"
                        checked={tipoAmortizacion === "T"}
                        onChange={() => setTipoAmortizacion("T")}
                        disabled={info.tipo_amortizacion !== null}
                      />
                      Amortizaciones fijas de capital
                    </label>
                  </div>
                </div>

                {tipoAmortizacion === "T" &&
                  info.tipo_amortizacion === null && (
                    <TablaAmortizacionesModal
                      tablaAmortizacion={tablaAmortizacion}
                      setTablaAmortizacion={setTablaAmortizacion}
                    />
                  )}
              </div>
              <div className="pedido-maquinaria-detalle-financiamiento-container-boton-add">
                <button
                  className="pedido-maquinaria-detalle-financiamiento-container-boton-eliminar-todo"
                  onClick={() => EliminarTodosRegistro()}
                >
                  Borrar amortizaciones
                </button>

                {tipoAmortizacion === "T" && info.tipo_amortizacion === null ? (
                  <Button
                    onClick={() => onCrearTablaAmortizacion()}
                    variant="contained"
                    sx={{ height: "30px" }}
                  >
                    Generar amortización
                  </Button>
                ) : (
                  <Button
                    onClick={() => openModal(-1)}
                    variant="contained"
                    sx={{ height: "30px" }}
                  >
                    Agregar amortización
                  </Button>
                )}
              </div>
            </div>
          ) : (
            <div className="pedido-maquinaria-detalle-financiamiento-container-boton-JDF-container">
              {/* <div className="pedido-maquinaria-detalle-financiamiento-container-boton-JDF-insoluto"> */}
              <div className="pedido-maquinaria-detalle-financiamiento-container-boton-JDF-insoluto">
                <span className="info-cuadro-textos-titulos">
                  Valor de operación:
                </span>
                <div className="info-cuadro-textos-datos">
                  <div>$</div>
                  <div>{FormatMoney(info.valor_operacion)}</div>
                </div>
              </div>
              {/* </div> */}
              <div className="pedido-maquinaria-detalle-financiamiento-container-boton-JDF">
                <Button
                  onClick={() => openModal(-1)}
                  variant="contained"
                  sx={{ height: "30px" }}
                >
                  Agregar amortización
                </Button>

                <button
                  className="pedido-maquinaria-detalle-financiamiento-container-boton-eliminar-todo-JDF"
                  onClick={() => EliminarTodosRegistro()}
                >
                  Borrar amortizaciones
                </button>
              </div>
            </div>
          )}

          <ModalAgregar />

          <div className="pedido-maquinaria-detalle-financiamiento-container-tabla scroll">
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th>DOCTO</th>
                  <th>VENCIMIENTO</th>
                  <th>IMPORTE A FINANCIAR</th>
                  <th>DIAS</th>
                  <th>TASA %</th>
                  <th>INTERÉS</th>
                  <th>TOTAL A PAGAR</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {unidades === undefined ||
                  unidades === null ||
                  unidades === 0 ? (
                  <>Sin Datos</>
                ) : (
                  unidades.map((item, index) => (
                    <tr>
                      <td>{item.docto}</td>
                      <td>{item.svencimiento}</td>
                      <td>{FormatMoney(item.importefinanciar)}</td>
                      <td>{item.dias}</td>
                      <td>{FormatMoney(item.tasa)}</td>
                      <td>{FormatMoney(item.interes)}</td>
                      <td>{FormatMoney(item.totalpagar)}</td>
                      {tipoAmortizacion === "M" ? (
                        <td>
                          {/* Solo mostrar CreateIcon si es el último elemento */}
                          {index === unidades.length - 1 && (
                            <CreateIcon onClick={() => openModal(item.docto)} />
                          )}
                        </td>
                      ) : tipoAmortizacion === "T" ? (
                        <td></td>
                      ) : (
                        <td>
                          <CreateIcon onClick={() => openModal(item.docto)} />
                        </td>
                      )}

                      {tipoAmortizacion === "M" ? (
                        <td>
                          {/* Solo mostrar CreateIcon si es el último elemento */}
                          {index === unidades.length - 1 && (
                            <DeleteIcon
                              onClick={() => EliminarRegistro(item)}
                            />
                          )}
                        </td>
                      ) : tipoAmortizacion === "T" ? (
                        <td></td>
                      ) : (
                        <td>
                          <DeleteIcon onClick={() => EliminarRegistro(item)} />
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>

              <tfoot>
                <tr>
                  <td>Total</td>
                  <td></td>
                  <td>
                    {FormatMoney(
                      unidades.reduce(
                        (sum, item) => sum + Number(item.importefinanciar),
                        0
                      )
                    )}
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    {FormatMoney(
                      unidades.reduce(
                        (sum, item) => sum + Number(item.interes),
                        0
                      )
                    )}
                  </td>
                  <td>
                    {FormatMoney(
                      unidades.reduce(
                        (sum, item) => sum + Number(item.totalpagar),
                        0
                      )
                    )}
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </Context.Provider>
  );
}

function ModalAgregar() {
  const { stateFinanciamiento, setStateFinanciamiento } = useContext(Context);
  const closeModal = () => {
    setStateFinanciamiento({
      ...stateFinanciamiento,
      open: false,
      docto: -120,
    });
  };

  const [interes, setInteres] = useState(0);
  const [detalle, setDetalle] = useState({
    docto: "",
    vencimiento: "",
    importe: 0,
    dias: "",
    tasa: "",
    intereses: 0,
    totalpagar: 0,
    importe_solicitado: 0,
    inicio_interes: "",
    enganche: "N",
    bdocto: "",
    bvencimiento: "",
    binicio_interes: "",
    bimporte: "",
    bdias: "",
    btasa: "",
    bintereses: "",
    btotalpagar: "",
    benganche: "",
    bimportesolicitado: false,
  });
  const [insolutoAnterior, setInsolutoAnterior] = useState(0);
  const [insolutoEditado, setInsolutoEditado] = useState(0);

  const onChange = (prop, value, sbool, smensaje) => {
    const sinComas = value.replace(/,/g, "");
    setDetalle({
      ...detalle,
      [prop]: sinComas,
      ["b" + prop]: false,
      ["m" + prop]: "",
    });
  };

  const onFocus = (e) => {
    e.target.type = "number";
  };

  const onBlur = (e, prop) => {
    e.target.type = "text";
    e.target.value = FormatMoney(Number(detalle[prop]));
  };

  const onGuardar = () => {


    var result = ValPedidoFinanciamiento(detalle);

    if (result.isValid === false) {
      Swal.fire(
        "PEDIDO DE MAQUINARIA",
        JSON.stringify(result.mensaje),
        "error"
      );
    } else {
      result.post.folio = stateFinanciamiento.folio;
      result.post.docto = stateFinanciamiento.docto;
      result.post.tipo_amortizacion = stateFinanciamiento.tipoAmortizacion;
      result.post.valor_insoluto =
        stateFinanciamiento.tipoAmortizacion === "M" && result.post.docto === -1
          ? stateFinanciamiento.valorInsoluto
          : stateFinanciamiento.tipoAmortizacion === "M" &&
            result.post.docto !== -1
            ? insolutoEditado
            : result.post.importefinanciar;
      request
        .post("PedidoFinanciamiento", result.post)
        .then(async () => {
          closeModal();
          await Swal.fire(
            "PEDIDO MAQUINARIA",
            "Registro guardado con exito",
            "success"
          );
          setDetalle({
            ...detalle,
            docto: "",
            vencimiento: "",
            importe: 0,
            dias: "",
            tasa: "",
            intereses: 0,
            totalpagar: 0,
            importe_solicitado: 0,
            inicio_interes: "",
            bdocto: "",
            bvencimiento: "",
            binicio_interes: "",
            bimporte: "",
            bdias: "",
            btasa: "",
            bintereses: "",
            btotalpagar: "",
            bimportesolicitado: false,
          });
        })
        .catch((error) => {
          Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "info");
        });
      // console.log(result.post)
    }
  };

  useEffect(() => {
    request
      .get(`PedidoFinanciamiento/GetTasa?folio=${stateFinanciamiento.folio}`)
      .then((result) => {
        setInteres(result.taza);
      })
      .catch((error) => {
        // setLoader({ ...loader, mostrar: false });
        Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
      });
  }, []);

  useEffect(() => {
    if (
      stateFinanciamiento.docto !== undefined &&
      stateFinanciamiento.docto !== null
    ) {
      request
        .get(
          `PedidoFinanciamiento/GetByRegistro?folio=${stateFinanciamiento.folio}&docto=${stateFinanciamiento.docto}`
        )
        .then((result) => {
          if (Number(result.importe_solicitado) === 0) {
            Swal.fire(
              "DETALLE DE PEDIDO",
              "Ya se cubrio el total a financiar",
              "info"
            );
            closeModal();
            return;
          }
          if (stateFinanciamiento.docto === -1) {
            setDetalle({
              ...detalle,
              importe_solicitado: result.importe_solicitado,
            });
            setInsolutoAnterior(0);
            return;
          }
          setDetalle({
            ...detalle,
            vencimiento: result.dvencimiento,
            inicio_interes:
              result.dinicio_interes === "0001-01-01"
                ? ""
                : result.dinicio_interes,
            importe: result.importefinanciar,
            dias: result.dias,
            tasa: result.tasa,
            intereses: result.interes,
            totalpagar: result.totalpagar,
            importe_solicitado: result.importe_solicitado,
            enganche: result.interes === 0 ? "S" : "N",
          });
          setInsolutoAnterior(result.importefinanciar);
          var financiamiento = document.getElementById("financiamineto");
          if (financiamiento !== undefined && financiamiento !== null) {
            financiamiento.value = FormatMoney(result.importefinanciar);
          }
          var intereses = document.getElementById("intereses");
          if (intereses !== undefined && intereses !== null) {
            intereses.value = FormatMoney(result.interes);
          }
        })
        .catch((error) => {
          // setLoader({ ...loader, mostrar: false });
          Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
        });
    }
  }, [stateFinanciamiento.docto]);

  useEffect(() => {
    var importe =
      detalle.importe === undefined ||
        detalle.importe === null ||
        detalle.importe === ""
        ? 0
        : Number(detalle.importe);

    var tasa =
      detalle.tasa === undefined || detalle.tasa === null || detalle.tasa === ""
        ? 0
        : Number(detalle.tasa);

    var dias =
      detalle.dias === undefined || detalle.dias === null || detalle.dias === ""
        ? 0
        : Number(detalle.dias);

    if (
      stateFinanciamiento.tipoAmortizacion === "M" &&
      stateFinanciamiento.docto === -1 &&
      detalle.enganche !== "S"
    ) {
      var intereses =
        importe === 0 || tasa === 0 || dias === 0
          ? 0
          : ((Number(stateFinanciamiento.valorInsoluto) * Number(tasa)) /
            100 /
            360) *
          Number(dias);
      setDetalle({
        ...detalle,
        totalpagar: Number(importe) + Number(intereses),
        intereses,
      });
    } else if (
      stateFinanciamiento.tipoAmortizacion === "M" &&
      stateFinanciamiento.docto !== -1 &&
      detalle.enganche !== "S"
    ) {
      const valorInsolutoTotal =
        Number(stateFinanciamiento.valorInsoluto) + Number(insolutoAnterior);
      var intereses =
        importe === 0 || tasa === 0 || dias === 0
          ? 0
          : ((Number(valorInsolutoTotal) * Number(tasa)) / 100 / 360) *
          Number(dias);
      setDetalle({
        ...detalle,
        totalpagar: Number(importe) + Number(intereses),
        intereses,
      });
      setInsolutoEditado(valorInsolutoTotal);
    } else if (
      stateFinanciamiento.tipoAmortizacion === "M" &&
      stateFinanciamiento.docto !== -1 &&
      detalle.enganche === "S"
    ) {
      const valorInsolutoTotal =
        Number(stateFinanciamiento.valorInsoluto) + Number(insolutoAnterior);
      var intereses = 0;
      setDetalle({
        ...detalle,
        totalpagar: Number(importe) + Number(intereses),
        intereses,
      });
      setInsolutoEditado(valorInsolutoTotal);
    } else if (
      stateFinanciamiento.tipoAmortizacion === "M" &&
      stateFinanciamiento.docto === -1 &&
      detalle.enganche === "S"
    ) {
      var intereses = 0;
      setDetalle({
        ...detalle,
        totalpagar: Number(importe) + Number(intereses),
        intereses,
      });
    } else if (detalle.enganche === "S") {
      var intereses = 0;
      setDetalle({
        ...detalle,
        totalpagar: Number(importe) + Number(intereses),
        intereses,
      });
    } else {
      var intereses =
        importe === 0 || tasa === 0 || dias === 0
          ? 0
          : ((Number(importe) * Number(tasa)) / 100 / 360) * Number(dias);
      setDetalle({
        ...detalle,
        totalpagar: Number(importe) + Number(intereses),
        intereses,
      });
    }
  }, [detalle.importe, detalle.tasa, detalle.dias, detalle.enganche]);

  useEffect(() => {
    if (detalle.vencimiento !== "" && detalle.inicio_interes !== "") {
      // if (detalle.vencimiento < detalle.inicio_interes) {
      //   Swal.fire(
      //     "PEDIDO DE MAQUINARIA",
      //     "La fecha de vencimiento no puede ser menor a la de inicio",
      //     "error"
      //   );
      //   setDetalle({ ...detalle, vencimiento: "", inicio_interes: "" })
      // }
      // else {
      //   const fechaInicio = new Date(detalle.inicio_interes);
      //   const fechaVencimiento = new Date(detalle.vencimiento);

      //   const diferenciaMs = fechaVencimiento - fechaInicio;
      //   const diferenciaDias = Math.ceil(diferenciaMs / (1000 * 60 * 60 * 24));

      //   // Si quieres guardar la diferencia en el estado:
      //   setDetalle(prev => ({ ...prev, dias: diferenciaDias }));
      // }

      const fechaInicio = new Date(detalle.inicio_interes);
      const fechaVencimiento = new Date(detalle.vencimiento);

      const diferenciaMs = fechaVencimiento - fechaInicio;
      const diferenciaDias = Math.ceil(diferenciaMs / (1000 * 60 * 60 * 24));

      // Si quieres guardar la diferencia en el estado:
      setDetalle((prev) => ({ ...prev, dias: diferenciaDias }));
    }
  }, [detalle.inicio_interes, detalle.vencimiento]);
  return (
    <Modal open={stateFinanciamiento.open}>
      <div className="dash-clientes-credito-crear-solicitud-modal">
        <div className="dash-clientes-credito-crear-detalle-financiamiento-modal-title">
          DETALLE DEL FINANCIAMIENTO
        </div>
        <div className="plantilla-screen-efecto-a">
          <div className="plantilla-screen-efecto-bl"></div>
          <div className="plantilla-screen-efecto-circle"></div>
          <div className="plantilla-screen-efecto-br"></div>
        </div>

        <div className="dash-clientes-credito-crear-solicitud-modal-container-financiamiento">
          <TextField
            fullWidth
            // disabled={state.tipo_solicitud === "C" ? true : false}
            size="small"
            label="¿Se cobrara interés?"
            variant="outlined"
            select
            type="text"
            className="cel-0-1"
            onChange={({ target }) => {
              setDetalle({ ...detalle, enganche: target.value });
            }}
            value={detalle.enganche}
            sx={{
              "& .MuiInputBase-root": {
                height: "35px", // Cambia el valor para ajustar la altura
              },
            }}
          >
            <MenuItem value="S">NO</MenuItem>
            <MenuItem value="N">SI</MenuItem>
          </TextField>

          {/* <TextField
            fullWidth
            // disabled={state.tipo_solicitud === "C" ? true : false}
            size="small"
            label="Enganche"
            variant="outlined"
            select
            type="text"
            className="cel-0-1"
            onChange={({ target }) => {
              setDetalle({ ...detalle, enganche: target.value });
            }}
            value={detalle.enganche}
            sx={{
              "& .MuiInputBase-root": {
                height: "35px", // Cambia el valor para ajustar la altura
              },
            }}
          >
            <MenuItem value="N">NO</MenuItem>
            <MenuItem value="S">SI</MenuItem>
          </TextField> */}

          <TextField
            fullWidth
            size="small"
            label="Inicio de calculo de interés"
            variant="outlined"
            className="cel-1-1"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Agriculture fontSize="small" />
                </InputAdornment>
              ),
            }}
            type="date"
            onChange={({ target }) => {
              setDetalle({ ...detalle, inicio_interes: target.value });
            }}
            value={detalle.inicio_interes}
          ></TextField>

          <TextField
            fullWidth
            size="small"
            label="Vencimiento"
            variant="outlined"
            className="cel-1-2"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Agriculture fontSize="small" />
                </InputAdornment>
              ),
            }}
            type="date"
            onChange={({ target }) => {
              setDetalle({ ...detalle, vencimiento: target.value });
            }}
            value={detalle.vencimiento}
          ></TextField>
          {/* <TextField
            fullWidth
            size="small"
            label="Tasa %"
            variant="outlined"
            className="pr-5 cel-2"
            select
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PercentIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiInputBase-root": {
                height: "34px", // Cambia el valor para ajustar la altura
              },
            }}
            type="text"
            onChange={({ target }) => {
              setDetalle({
                ...detalle,
                tasa: target.value,
                btasa: false,
              });
            }}
            value={detalle.tasa}
          >
            <MenuItem value={interes}>{interes}</MenuItem>
            <MenuItem value={0}>0</MenuItem>
          </TextField> */}

          <TextField
            className="cel-2"
            size="small"
            label="Tasa %"
            variant="outlined"
            type="number"
            error={detalle.btasa}
            // onKeyUp={(input) => Moneda(input.target)}
            onChange={({ target }) => {
              ValOnlyNumber("tasa", target.value, onChange, true, 10);
            }}
            value={detalle.tasa}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PercentIcon />
                </InputAdornment>
              ),
            }}
            inputProps={{
              style: { textAlign: "right" },
            }}
          />
          <TextField
            className="pr-5"
            size="small"
            label="Dias"
            variant="outlined"
            type="text"
            error={detalle.bdias}
            onChange={({ target }) => {
              ValTextAndNumber("dias", target.value, onChange, true, 10);
            }}
            value={detalle.dias}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start"></InputAdornment>
              ),
            }}
            disabled={true}
            inputProps={{
              style: { textAlign: "right" },
            }}
          />
          <TextField
            className=" cel-4"
            size="small"
            id="financiamineto"
            label="Importe a Financiar"
            variant="outlined"
            type="text"
            error={detalle.bimporte}
            onChange={({ target }) => {
              ValTextAndNumber("importe", target.value, onChange, true, 10);
            }}
            // onFocus={onFocus}
            // onBlur={(e) => onBlur(e, "importe")}
            onKeyUp={(input) => Moneda(input.target)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoneyIcon />
                </InputAdornment>
              ),
            }}
            inputProps={{
              style: { textAlign: "right" },
            }}
          />
          <TextField
            className="cel-5"
            fullWidth
            size="small"
            label="Intereses"
            variant="outlined"
            type="text"
            id="intereses"
            value={FormatMoney(detalle.intereses)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoneyIcon />
                </InputAdornment>
              ),
            }}
            disabled={true}
            inputProps={{
              style: { textAlign: "right" },
            }}
          ></TextField>

          <TextField
            disabled={true}
            className="cel-6"
            size="small"
            label="Total a Pagar"
            variant="outlined"
            type="text"
            value={FormatMoney(detalle.totalpagar)}
            onFocus={onFocus}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoneyIcon />
                </InputAdornment>
              ),
            }}
            inputProps={{
              style: { textAlign: "right" },
            }}
          ></TextField>
        </div>

        <div className="dash-clientes-credito-crear-solicitud-modal-button-container">
          <Button onClick={closeModal} variant="contained" color="error">
            Cerrar
          </Button>
          <Button variant="contained" onClick={() => onGuardar()}>
            Agregar
          </Button>
        </div>
      </div>
    </Modal>
  );
}